import { Component } from '@angular/core';

@Component({
  selector: 'wun-blogs',
  imports: [],
  templateUrl: './blogs.component.html',
  styleUrl: './blogs.component.scss'
})
export class BlogsComponent {

}
